import { uniqueId } from "@/views/zhiji/js/common/util.js";

const color = "#ffa500";

function getElem(node) {
    return {
        id: node.id,
        tag: "p",
        innerText: node.word,
        attrs: [{ name: "data-type", value: "highlight" }],
        styles: [{ name: "color", value: color }]
    };
}

// link，question，higlight配置
export default {
    type: "highlight",
    labelKey: "zhiji.answer.textWidget.hightTip",
    cls: "highlight-word",
    tipsComponent: null,
    editorHandler: (store, data, cb) => {
        // 当前选中的内容在hightlight节点内，取消当前节点highlight效果
        if (data.selectedNode && data.selectedNode.type === "highlight") {
            cb({ elem: { id: data.selectedNode.id }, operate: "delete" });
            return;
        }
        // 点击highlight节点不做操作
        if (data.id) {
            return;
        }
        // 新增操作
        const id = `${uniqueId()}`;
        const node = {
            id,
            type: "highlight",
            word: data.word
        };
        const elem = getElem(node);

        cb({ elem, node, operate: "add" });
    },
    beforeInsert(node, insertNode) {
        if (!insertNode.word) {
            return;
        }
        const ret = {
            before: { node: [], elem: [] },
            after: { node: [], elem: [] }
        };
        const selectedText = insertNode.word;
        const highlightText = node.word;
        const startIndex = highlightText.indexOf(selectedText);
        const endIndex = startIndex + selectedText.length;
        // 开始留有部分没选中
        if (startIndex > 0) {
            const startNode = { ...node, word: highlightText.substring(0, startIndex), id: `${uniqueId()}` };
            ret.before.node.push(startNode);
            ret.before.elem.push(getElem(startNode));
        }
        // 结尾留有部分没选中
        if (endIndex < highlightText.length) {
            const endNode = { ...node, word: highlightText.substring(endIndex), id: `${uniqueId()}` };
            ret.after.node.push(endNode);
            ret.after.elem.push(getElem(endNode));
        }
        return ret;
    },
    toHtml(node) {
        return `<span id=${node.id} style="color: ${color}" data-type="highlight">${node.word}</span>`;
    },
    fromOut(word) {
        return { ...word };
    },
    toOut(node) {
        return { ...node };
    },
    getTips() {
        return "";
    }
};
